'use client';
import React from 'react';

interface Device {
  name: string;
  icon: React.ReactNode;
}

const devices: Device[] = [
  {
    name: 'Apple TV',
    icon: (
      <svg viewBox="0 0 40 40" className="w-10 h-10" fill="currentColor">
        <path d="M20 4C11.163 4 4 11.163 4 20s7.163 16 16 16 16-7.163 16-16S28.837 4 20 4zm0 2c7.732 0 14 6.268 14 14s-6.268 14-14 14S6 27.732 6 20 12.268 6 20 6zm-2 7v2h4v-2h-4zm0 4v10h4V17h-4z"/>
      </svg>
    ),
  },
  {
    name: 'iOS',
    icon: (
      <svg viewBox="0 0 40 40" className="w-10 h-10" fill="currentColor">
        <path d="M26.5 8C24.5 8 23 9.5 23 11.5c0 1.7 1.1 3.2 2.7 3.8-.2.5-.5 1-.9 1.4-1 1-2.3 1.3-3.5 1.3-1.3 0-2.5-.4-3.5-1.3-1-.9-2.2-1.3-3.5-1.3-1.3 0-2.7.5-3.8 1.5C9.2 18 8 20.5 8 23.5c0 3.5 1.5 7.5 3.5 9.5.8.8 1.7 1 2.5 1 1 0 1.8-.3 2.7-.3.8 0 1.7.3 2.7.3.8 0 1.7-.3 2.5-1 .7-.7 1.3-1.7 1.8-2.8-1.5-.7-2.7-2.3-2.7-4.2 0-2 1.3-3.7 3-4.3-.5-.7-.8-1.5-.8-2.5 0-2.2 1.8-4 4-4 .3 0 .7 0 1 .1V8h-.5z"/>
      </svg>
    ),
  },
  {
    name: 'Roku',
    icon: (
      <svg viewBox="0 0 40 40" className="w-10 h-10" fill="currentColor">
        <rect x="8" y="8" width="24" height="24" rx="4"/>
        <rect x="14" y="14" width="12" height="12" rx="2" fill="#171725"/>
      </svg>
    ),
  },
  {
    name: 'Fire TV',
    icon: (
      <svg viewBox="0 0 40 40" className="w-10 h-10" fill="currentColor">
        <path d="M20 6c-7.7 0-14 6.3-14 14s6.3 14 14 14 14-6.3 14-14S27.7 6 20 6zm0 4c5.5 0 10 4.5 10 10s-4.5 10-10 10S10 25.5 10 20s4.5-10 10-10zm-2 4v4h-4v4h4v4h4v-4h4v-4h-4v-4h-4z"/>
      </svg>
    ),
  },
  {
    name: 'Android TV',
    icon: (
      <svg viewBox="0 0 40 40" className="w-10 h-10" fill="currentColor">
        <path d="M8 12h24v16H8z" rx="2"/>
        <path d="M16 30h8v2h-8z"/>
        <path d="M18 28h4v4h-4z" fill="#171725"/>
        <circle cx="14" cy="20" r="2" fill="#171725"/>
        <circle cx="26" cy="20" r="2" fill="#171725"/>
      </svg>
    ),
  },
  {
    name: 'LG Smart TV',
    icon: (
      <svg viewBox="0 0 40 40" className="w-10 h-10" fill="currentColor">
        <rect x="6" y="8" width="28" height="20" rx="2"/>
        <path d="M14 30h12v2H14z"/>
        <rect x="10" y="12" width="20" height="12" rx="1" fill="#171725"/>
      </svg>
    ),
  },
  {
    name: 'Samsung TV',
    icon: (
      <svg viewBox="0 0 40 40" className="w-10 h-10" fill="currentColor">
        <rect x="4" y="8" width="32" height="22" rx="2"/>
        <path d="M16 32h8v2h-8z"/>
        <rect x="8" y="12" width="24" height="14" rx="1" fill="#171725"/>
      </svg>
    ),
  },
  {
    name: 'Vizio',
    icon: (
      <svg viewBox="0 0 40 40" className="w-10 h-10" fill="currentColor">
        <rect x="5" y="9" width="30" height="20" rx="3"/>
        <path d="M15 31h10v2H15z"/>
        <rect x="9" y="13" width="22" height="12" rx="1" fill="#171725"/>
      </svg>
    ),
  },
  {
    name: 'Web Browser',
    icon: (
      <svg viewBox="0 0 40 40" className="w-10 h-10" fill="currentColor">
        <circle cx="20" cy="20" r="14"/>
        <path d="M20 6c-7.7 0-14 6.3-14 14s6.3 14 14 14 14-6.3 14-14S27.7 6 20 6zm0 2c1.5 0 3.3 2.5 4.5 6.5H15.5C16.7 10.5 18.5 8 20 8zm-5.5 8h11c.3 1.3.5 2.6.5 4s-.2 2.7-.5 4h-11c-.3-1.3-.5-2.6-.5-4s.2-2.7.5-4zm-6.3 0h4.3c-.3 1.3-.5 2.6-.5 4s.2 2.7.5 4H8.2C7.4 22.7 7 21.4 7 20s.4-2.7 1.2-4zm23.6 0h4.3c.8 1.3 1.2 2.6 1.2 4s-.4 2.7-1.2 4h-4.3c.3-1.3.5-2.6.5-4s-.2-2.7-.5-4z" fill="#171725"/>
      </svg>
    ),
  },
  {
    name: 'Xbox',
    icon: (
      <svg viewBox="0 0 40 40" className="w-10 h-10" fill="currentColor">
        <circle cx="20" cy="20" r="14"/>
        <path d="M14 14l12 12M26 14L14 26" stroke="#171725" strokeWidth="3" strokeLinecap="round"/>
      </svg>
    ),
  },
];

export default function DevicesSection() {
  return (
    <section className="py-16 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto text-center">
        <h2 className="text-[28px] sm:text-[32px] font-black text-white mb-3">
          Watch on{' '}
          <span className="text-gradient-blue">20+ Top Devices</span>
        </h2>
        <p className="text-[#979797] text-base mb-10">
          Sling Consonantal Digital works on all your favorite devices — wherever you are.
        </p>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-10 gap-4 mb-8">
          {devices.map((device, i) => (
            <div key={i} className="device-logo flex-col gap-2 cursor-pointer">
              <div className="text-white">{device.icon}</div>
              <span className="text-[#979797] text-[10px] font-bold text-center leading-tight">{device.name}</span>
            </div>
          ))}
        </div>

        <p className="text-[#979797] text-sm">
          See all our{' '}
          <a href="#" className="text-[#00b9ff] font-bold hover:underline">
            supported devices
          </a>
        </p>
      </div>
    </section>
  );
}
